/*eslint-disable no-undef*/
/*global translate*/
import { connect } from 'react-redux'
import React, { Component } from 'react'

const { chooseGroupAction, changeGroupFunc } = global.rootRequire('redux')

const { rxaget, rxChangeSlug, autoConvertTime, changeColorSVG } = global.rootRequire('classes/ulti')
const { parseMessageDesc, changeColorAva, textAva } = global.rootRequire('classes/chat')
const { apiGetUserStatus } = global.rootRequire('classes/api')
// const { rxgetLocal } = global.rootRequire('classes/request')

// const workerGroup = global.rootRequire('classes/globalGroups')
const worker = global.rootRequire('classes/globalUser')
const workerUnread = global.rootRequire('classes/globalUnread')
// const rxio = global.rootRequire('classes/socket').default
const chatDB = global.rootRequire('classes/indexedDB').default
let zget = global.rxu.get

let users = {}
// let checkImage = {}
// let group_id = ''
// let linkava = ''
let statusInput = ''


class GroupItem_ extends Component {
  _isMounted = false
  constructor(props, context) {
    super(props, context)
    this.state = {
      groupChooseItem_selected: {},
      // flagActive: false,
      groupObj: this.props.groupObj || {},
      // groupIndex: this.props.groupIndex
    }

    this.userid = rxaget(this.props, 'netaauth.user.id', '')
    this.token = rxaget(this.props, 'netaauth.user.token', '')
    this.descMess = parseMessageDesc(rxaget(this.props.groupObj, 'last_message', {}), users, this.props.userid, rxaget(this.props.groupObj, 'admin_uins', []))
    this.user = {}
    this.groupIdFirst = rxaget(this.props, 'rxgroup.group.group_id', '')
    this.countUnread = 0// (rxaget(this.props.groupObj, 'count_unread', 0) > 0) ? rxaget(this.props.groupObj, 'count_unread', 0) : rxaget(this.props.groupObj, 'unread_cnt', 0)  
  }

  shouldComponentUpdate(nextProps, nextState) { 
    try {
      let flagReturn = false
      if (rxaget(this.props.groupObj, 'last_sort', '') !== rxaget(nextProps.groupObj, 'last_sort', '')) {
        flagReturn = true
      } else if (this.props.groupObj.group_id !== nextProps.groupObj.group_id) {
        flagReturn = true
      } else if (this.props.groupObj.group_id === this.props.groupIdActive || nextProps.groupObj.group_id === nextProps.groupIdActive) {
        flagReturn = true
      } else if (this.props.groupObj.count_unread !== nextProps.groupObj.count_unread) {
        flagReturn = true
      } else if (this.props.groupObj.another_seen_mess !== nextProps.groupObj.another_seen_mess) {
        flagReturn = true
      } else if (this.props.groupObj.group_fullname !== nextProps.groupObj.group_fullname) {
        flagReturn = true
      } else if (this.props.groupObj.type === 3 && this.props.groupObj.partner_id && (rxaget(this.user, 'Id', '').toString() !== this.props.groupObj.partner_id || rxaget(this.user, 'full_name', '') !== rxaget(worker.users[this.props.groupObj.partner_id], 'full_name', '') || rxaget(this.user, 'profile_url', '') !== rxaget(worker.users[this.props.groupObj.partner_id], 'profile_url', ''))) {
        this.user = worker.users[this.props.groupObj.partner_id]
        flagReturn = true
      }

      if (flagReturn) {
        this.descMess = parseMessageDesc(rxaget(nextProps, 'groupObj.last_message', {}), users, this.props.userid, rxaget(nextProps, 'groupObj.admin_uins', []))
        this.state.groupObj = rxaget(nextProps, 'groupObj', {})
      }
      return flagReturn
    } catch(e) {
      return true
    }
  }
  
  componentDidMount() {
    this._isMounted = true
    // this.updateUserID = this.updateUser();
  }

  updateUser = (groupObj) => setTimeout(() => {
    // if (rxaget(groupObj, 'group_fullname', '') === translate('Stranger') ) {
    //   if (worker.users && worker.users[rxaget(groupObj, 'partner_id', '')]) {
    //     groupObj['group_fullname'] =  worker.users[rxaget(groupObj, 'partner_id', '')]['full_name'] 
    //     if (this._isMounted) {
    //       this.setState({
    //         groupObj: groupObj
    //       })
    //     }
    //   }  
    // }
  }, 5000);

  componentWillUnmount() {
    this._isMounted = false
    // clearTimeout(this.updateUserID);
  }

  chooseGroup(group) {
    // if(group.type === 3){
    //   this.checkUserStatus(group)
    // }

    this.props.chooseGroup(group)
    this.props.chooseGroupAction(group)
    this.countUnread = 0
    group.count_unread = 0


    let timenow = Math.floor(Date.now() / 1000)
    // let updateObj = {count_unread: 0}
    let updateObj = {my_messid_tag: ''}

    if (!group.update_cache || (timenow - Number(group.update_cache) > 21600)) {
      updateObj['update_cache'] = timenow
      this.fetchGroupDetail(group.group_id)
    }
    workerUnread.initUnread(group.group_id.toString(), '-1')
    chatDB.groups.update(group.group_id.toString(), updateObj).then(o => {
      this.props.changeGroupFunc()
      this.setState({
        groupObj: group
      })
    }).catch(e => {})

  }

  fetchGroupDetail(group_id) {
    chatDB.groups.get({group_id: group_id}).then(groupInDB => {
      if (groupInDB && groupInDB.occupants_uins) {
        const api_group_detail = global.rxu.config.get_groups + '/' + group_id
        fetch(api_group_detail, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'TC-Token': this.props.usertoken,
            Connection: 'Keep-Alive',
            'Accept-Encoding': 'gzip'
          },
          body: null
        }).then(res => res.json()).then((json) => {
          if (json && json.Code === 401 && json.Message === "Unauthorized") {
            try {} catch(e) {}
          }

          let objUsers = []
          
          if (json) {
            if (json.users && json.users.constructor === Array && json.users.length > 0) {
              for (const user of json.users) {
                if (!(rxaget(user, 'full_name', '') || rxaget(user, 'phone', ''))) {
                  user.full_name = translate('Stranger')
                }
                worker.addUser(user.Id, { id: user.Id, uid: user.Id,  ...user })
                objUsers.push({ id: user.Id, uid: user.Id,  ...user })  
              }
            }
            if (json.removed_users && json.removed_users.constructor === Array && json.removed_users.length > 0) {
              for (const user of json.removed_users) {
                worker.addUser(user.Id, { id: user.Id, uid: user.Id,  ...user })
                if (rxaget(user, 'full_name', '') || rxaget(user, 'phone', '')) {
                  objUsers.push({ id: user.Id, uid: user.Id,  ...user })  
                }
              }
            }
            if (json.Group && json.Group.group_id.toString() === group_id.toString()) {
              chatDB.users.bulkPut(objUsers)
            }
          }  

          if (groupInDB.partner_id) {
            let findUser = objUsers.find(u => u.id === Number(groupInDB.partner_id))



            if (findUser && (rxaget(findUser, 'full_name', '') || rxaget(findUser, 'phone', ''))) {
              let group_fullname = findUser.full_name || findUser.phone

              if (group_fullname !== groupInDB.group_fullname) {
                groupInDB.group_fullname = group_fullname
                chatDB.groups.update(groupInDB.group_id, {group_fullname: group_fullname}).then(o => {
                  this.props.changeGroupFunc()
                }).catch(e => {})      

                this.props.chooseGroup(groupInDB)
                this.props.chooseGroupAction(groupInDB)
              }    
            }
          }        
        }).catch(error => {
          console.log(error)
        })

      }
    })  
  }

  onRightClickGroup(e, group) {
    this.props.onRightClickGroup(e, group)
  }

  checkGroupSeen(group) {
    const unread = Number(rxaget(group, 'unread_cnt', 0))
    if (unread > 0) {
      return true
    } else {
      if (rxaget(group, 'count_unread', 0) > 0) {
        return true
      } else {
        return false
      }
    }
  }


  checkIsTagNameInMess(ele){
    if (ele.my_messid_tag && ele.my_seen_mess && !isNaN(ele.my_messid_tag) && !isNaN(ele.my_seen_mess)) {
      try {
        if (BigInt(ele.my_messid_tag) > BigInt(ele.my_seen_mess)) {
          return true
        } else {
          return false
        }
      } catch(e) {
        console.log(e)
        return false
      }
    } else {
      return false
    }
  }

  checkGroupsPinned_uins = (pinned_uins) => {
    let flag = false
    if (pinned_uins && pinned_uins.constructor === Array && pinned_uins.indexOf(String(this.props.userid)) !== -1) {
      flag = true
    }
    return flag
  }

  onClickShowPopup_ManageGroup() {}
  groupChooseItem() {}

  checkDisableNoti(group_id) {
    let netaAuthSetting = JSON.parse(localStorage.getItem('netaAuthSetting') || `{"groups":{}}`)
    let notificationStatus = this.state.notificationStatus
    if (notificationStatus === true && netaAuthSetting && netaAuthSetting.groups && netaAuthSetting.groups[Number(group_id)]) {
      let groupDisableNoti = netaAuthSetting.groups[Number(group_id)].disableNoti
      return groupDisableNoti
    } else {
      return false
    }
  }
  
  checkGroupsPinned_uins(pinned_uins) {
    let flag = false
    if (pinned_uins && pinned_uins.constructor === Array && pinned_uins.indexOf(String(this.props.userid)) !== -1) {
      flag = true
    }
    return flag
  }


  showUserName(group) {
    if (group && group.type === 3) {
      if (worker.users[rxaget(group, 'partner_id', '')] && worker.users[rxaget(group, 'partner_id', '')]['full_name']) {
        return worker.users[rxaget(group, 'partner_id', '')]['full_name']  
      } else {
        return translate('Stranger')
      }
      
    } else {
      if (rxaget(group, 'group_fullname', '') !== translate('Stranger')) {
        return rxaget(group, 'group_fullname', '')
      } else {
        return rxaget(group, 'name', '')
      }
    }
  }

  leaveGroupBtnClick() {}

  checkGroupsAdminLeave(groupTmp, mess) {
    let showNoti = true
    try {
      if (groupTmp && groupTmp.type !== 3 && groupTmp.admin_uins && groupTmp.admin_uins.constructor === Array && (groupTmp.admin_uins.indexOf(this.props.userid.toString()) === -1 || groupTmp.owner_uin.toString() !== this.props.userid.toString() ) && mess && mess.type === 7) {
        showNoti = false
      }
    } catch(e) {
    }
    return showNoti
  }

  checkUserStatus(group){
    let partner_id = group.partner_id
    // let partner_id = '4785074617643091'
    // this.token = '0409af0af8875c4b4c0482d5a2e514363c5b9X0K'
    apiGetUserStatus(this.token, partner_id, (json)=>{
      if(json && json.status_message){
        let userStatus = json
        // let userStatus = {}
        let updateObj = {
          userStatus : userStatus
        }
        if(this.getUserStatus_txt(group.userStatus)!== this.getUserStatus_txt(userStatus)){
          group.userStatus = {...userStatus}
          this.props.chooseGroupAction(group)
          chatDB.groups.update(group.group_id.toString(), updateObj).then(o => {
            this.props.changeGroupFunc()
          }).catch(e => {})
        }

      }
    })
  }

  getUserStatus_txt(userStatus){
    let user_status_txt = ''
    if(userStatus){
      user_status_txt = this.props.langValue === 'en' ? userStatus.status_message_en : userStatus.status_message
    }
    return user_status_txt
  }



  render() {

    let ele = this.state.groupObj 
    let partnerUSer = {}
    if (ele && ele.type === 3) {
      partnerUSer = worker.users[ele.partner_id]
    }
    this.groupIdFirst = this.props.groupIdActive || this.groupIdFirst

    return (<div className={(ele.group_id === this.groupIdFirst) ? 'zgroupitem active clearfix' :(this.checkGroupsPinned_uins(ele.pinned_uins) ? 'zgroupitem zgroup-pin clearfix':'zgroupitem clearfix') } onClick={e => { this.chooseGroup(ele) }} onContextMenu={e => {this.onRightClickGroup(e, ele)}}>             
      <div className='zgroup_avatar'>                      
        {/*{ele.avatar_url 
          ? 
          <img src={global.rxu.config.get_static + ele.avatar_url} alt='avatar_url' className='ava-group images-static'
          onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} /> 
          :
          (users[ele.partner_id] && users[ele.partner_id]['profile_url'] 
            ? <img src={`${global.rxu.config.cdn_endpoint}` + users[ele.partner_id]['profile_url']} alt='profile_url' data-id={'userava' + ele.partner_id} className='ava-usergroup images-static' 
            onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} /> 
             : checkImage[linkava + ele.partner_id] && <img src={checkImage[linkava + ele.partner_id]['link']} alt='linkava' className='ava-usergroup images-static' onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} />
          )
        }
        {
          !(ele.avatar_url || (users[ele.partner_id] && users[ele.partner_id]['profile_url']) )
          && <span className='ava-span' style={{ background: `${ ele?.type === 3 ? changeColorAva(rxaget(ele, 'partner_id', rxaget(ele, 'group_id', ''))) : changeColorAva(rxaget(ele, 'group_id', ''))}` }}>
            {textAva(rxChangeSlug(rxaget(ele, 'group_fullname', ''), true))}
          </span>  
        }*/}

        {(zget(ele, 'type', 0) === 3) && <React.Fragment>
          { zget(partnerUSer, 'profile_url', '') && <img src={global.rxu.config.get_static + zget(partnerUSer, 'profile_url', '')} alt='profile_url' className='ava-group_header images-static' onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} /> }
          { (!zget(partnerUSer, 'profile_url', '') && zget(ele, 'avatar_url', '')) &&  <img src={global.rxu.config.get_static + zget(ele, 'avatar_url', '')} alt='avatar_url' className='ava-group_header images-static' onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} /> }
          { (!zget(partnerUSer, 'profile_url', '') && !zget(ele, 'avatar_url', '')) && <span className='ava-span_header' style={{ background: `${changeColorAva(rxaget(ele, 'partner_id', rxaget(ele, 'group_id', '')))}` }}>
              {textAva(rxChangeSlug(zget(partnerUSer, 'full_name', ''))) || textAva(zget(ele, 'group_fullname', '')) }
            </span> 
          }
        </React.Fragment>}
        {(zget(ele, 'type', 0) !== 3) && <React.Fragment>
          { zget(ele, 'avatar_url', '') &&  <img src={global.rxu.config.get_static + zget(ele, 'avatar_url', '')} alt='avatar_url' className='ava-group_header images-static' onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} /> }
          { !zget(ele, 'avatar_url', '') && <span className='ava-span_header' style={{ background: `${changeColorAva(rxaget(ele, 'group_id', ''))}` }}>
              {textAva(rxChangeSlug(zget(ele, 'name', ''))) || textAva(zget(ele, 'group_fullname', '')) }
            </span> 
          }  
        </React.Fragment>}        

      </div>               
      
      <div className='zgroup_maininfo'>                                  
        <div className={statusInput===''?'zgroup_name':'zgroup_name_hiden'}>
          { ele.type === 4 && <img className ='zgroup_icon ' src='./images/default/static/channel-icon.svg' alt='' />}
          { ele.type === 2 && <img className ='zgroup_icon ' src='./images/default/static/group-icon.svg' alt='' />}

          { ele.count_unread > 0 && <div className='zgroup_name_info zgroup_name_info_bold'>{rxaget(ele, 'group_fullname', '')}</div>}
          { ele.count_unread == 0 && <div className='zgroup_name_info'>{((zget(ele, 'type', 0) === 3)) ? zget(partnerUSer, 'full_name', '') || rxaget(ele, 'group_fullname', '') : zget(ele, 'name', '') || rxaget(ele, 'group_fullname', '')}</div>}

          {this.checkDisableNoti(ele.group_id )&&<img className ='zgroup_noti filter_img_class' src='./images/default/icons/Mask-Group-10.svg' alt='' />}
        </div>
        
        <div className={statusInput===''?'zgroup_desc':'zgroup_desc_hiden'}>

          <div className='zgroup_messageDesc'>
          {
            ele.draft_mess && ele.draft_mess.message && ele.draft_mess.message.length > 0 ?
            (<div className='zgroup_messageDraftDesc'><span className='zgroup_DraftDescTitle'>Draft: </span> {ele.draft_mess.message}</div>) :
            ele.isDraft ? (<div className='zgroup_messageDraftDesc'><span className='zgroup_DraftDescTitle'>{"Draft"}</span></div>) : (this.checkGroupsAdminLeave(ele, ele.last_message)) ? this.descMess : ''
          } 
          </div>
          <div className = 'zgroup_icon-place'>
            {ele.count_unread > 0 ? <span className='zgroup_count_unread'>{ ele.count_unread }</span> : <span></span> } 
            {this.checkGroupsPinned_uins(ele.pinned_uins) && <img className ='pin-group-icon' src='./images/default/icons/pin-on.svg' alt='' />}
          </div>                    
        </div>
        
        <div className={statusInput===''?'zgroup_status':'zgroup_status_hiden'}>{ele.status}</div>
        <div className={statusInput===''?'zgroup_time':'zgroup_time_hiden'}>
          <span className='zgroup_time_checked'>
            {/* {(ele.count_unread > 0) && !this.checkIsTagNameInMess(ele) && <img className ='filter_img_class' src={changeColorSVG('./images/default/static/icon-checked.svg')} alt='' />} */}
            {(ele.last_message && this.props.userid && rxaget(ele, 'last_message.sender_uin', '') && rxaget(ele, 'last_message.sender_uin', '').toString() === this.props.userid.toString()) ? (ele.last_message.message_id !== ele.another_seen_mess ) ? <img className ='filter_img_class' src={changeColorSVG('./images/default/static/icon-checked.svg')} alt='' /> : <img className ='filter_img_class' src={changeColorSVG('./images/default/icons/readed-icon.svg')} alt='' /> : <></> }
            {(ele.count_unread > 0) && this.checkIsTagNameInMess(ele) && <span>@</span>} 
          </span>
          <span className='zgroup_time_last'>
            {
              ele.draft_mess && ele.draft_mess.message && ele.draft_mess.message.length > 0 ? 
              autoConvertTime(rxaget(ele, 'draft_mess.created_at', '')) :
              (
                (rxaget(ele, 'last_message.created_at', '')) ? autoConvertTime(rxaget(ele, 'last_message.created_at', '')) : (rxaget(ele, 'updated_at', '')) ? autoConvertTime(rxaget(ele, 'updated_at', '')) : autoConvertTime(rxaget(ele, 'created_at', ''))
              )
            }
          </span>
        </div>
        <div className='divider_area'></div>
      </div>


    </div>)
  }
}

const mapStateToProps = (state, ownProps) => ({
  netaauth: state.netaauth,
  user: state.user,
  rxgroup: state.rxgroup,
  rxChangeGroup: state.rxChangeGroup,
  langValue: state.langValue,
})

const mapDispatchToProps = {
  chooseGroupAction,
  changeGroupFunc
}

const GroupItem = connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupItem_)

export default GroupItem